import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import React from "react";
import { createRoot } from "react-dom/client";
import "url-polyfill";

import App from "./App";
import { FIREBASE_API_KEY, FIREBASE_PROJECT_ID } from "./constants";
import type { Bar } from "./models/bar";

const init = () => {
	console.log("initializing free-shipping-bar...");
	firebase.initializeApp({
		apiKey: FIREBASE_API_KEY,
		projectId: FIREBASE_PROJECT_ID,
	});
	const db = firebase.firestore();
	console.log("initialized firebase app");

	const el = document.createElement("div");
	el.setAttribute("id", "free-shipping-bar-container");
	document.body.appendChild(el);
	const root = createRoot(el);

	if (import.meta.env.SSR) {
		throw new Error("This script should not be imported in SSR");
	}
	const jsUrl = document.querySelector<HTMLScriptElement>(
		`script[id^='free-shipping-bar-script']`,
	)?.src;
	if (!jsUrl) {
		console.log("script element not found");
		root.render(<App bar={null} />);
		return;
	}

	const parsed = new URL(jsUrl);
	const barId = parsed.searchParams.get("barId");
	if (!barId) {
		console.log("barId not found");
		root.render(<App bar={null} />);
		return;
	}

	if (parsed.hostname === "localhost") {
		db.useEmulator("localhost", 8080);
		console.log("connected to firestore emulator");
	}
	console.log("barId:", barId);

	db.collection("bars")
		.doc(barId)
		.get()
		.then((doc) => {
			const data = doc.data();
			if (!data) {
				console.log("bar data not found");
				root.render(<App bar={null} />);
				return;
			}

			const bar = {
				...(data as Bar),
				id: barId,
			};

			// 正常なデータがあればそれを渡す
			root.render(<App bar={bar} />);
			return;
		})
		.catch((e) => {
			console.error(e);
			root.render(<App bar={null} />);
			return;
		});

	return;
};
init();
